import script from "./GeneratedResult.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneratedResult.vue?vue&type=script&setup=true&lang=js"

import "./GeneratedResult.vue?vue&type=style&index=0&id=3a9470b1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a9470b1"]])

export default __exports__